import parseISO from 'date-fns/parseISO';
import isValid from 'date-fns/isValid';
import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
import { getValidNumberWithLocalize, getLocale } from "./utils";

export default (col, options = {}) => {
  try {
    const sortOrder = (col.type === 'sortable-ascending' ? 1 : -1);

    const compare = (a, b) => (a > b ? 1 : a < b ? -1 : 0) * sortOrder;

    const compareDates = (a, b) => {
      if (a === null || b === null) return 0;
      if (a === null) return sortOrder;
      if (b === null) return -sortOrder;

      return (isBefore(a, b) ? -1 : isAfter(a, b) ? 1 : 0) * sortOrder;
    };

    const getFieldValue = (item, index) => item.fields[index]?.value || '';

    const parseDate = (date) => {
      const parsedDate = parseISO(date);
      return isValid(parsedDate) ? parsedDate : null;
    };

    const getArrayKeys = (item, index, key = "label") => {
      const value = getFieldValue(item, index);
      return Array.isArray(value) && value.length ? value.map(val => val[key])?.join(',') : value;
    };

    const getSorters = {
      compare,
      text: (a, b) => compare(getFieldValue(a, col.index), getFieldValue(b, col.index)),
      textCaseInsensitive: (a, b) => compare(getFieldValue(a, col.index).toLowerCase(), getFieldValue(b, col.index).toLowerCase()),
      date: (a, b) => compareDates(parseDate(getFieldValue(a, col.index)), parseDate(getFieldValue(b, col.index))),
      array: (a, b, key) => compare(getArrayKeys(a, col.index, key), getArrayKeys(b, col.index, key)),
      numeric: (a, b) => {
        const locale = getLocale(options?.locale);
        return compare(getValidNumberWithLocalize(getFieldValue(a, col.index), locale), getValidNumberWithLocalize(getFieldValue(b, col.index), locale));
      },
      alphaNumeric: (a, b) => {
        const locale = getLocale(options?.locale);
        return getFieldValue(a, col.index).localeCompare(getFieldValue(b, col.index), locale, { numeric: true }) * (col.type === 'sortable-ascending' ? 1 : -1);
      }
    };

    return getSorters;
  } catch (error) {
    console.error('Error in Sorters: ', error);
    return false;
  }
};